// this is an autogenerated file from DesignSystem/PatientInformation/Content/AppointmentBooking/Content/AppointmentHistory/Timeline/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PatientInformation_Content_AppointmentBooking_Content_AppointmentHistory_Timeline($appointment_id: uuid!) {
  vaxiom_appointment_booking_state_changes(
    where: { booking: { appointment: { _id: { _eq: $appointment_id } } } }
    order_by: [{ booking: { sys_created: asc }, change_time: asc }]
  ) {
    id
    change_time
    old_state
    new_state

    booking {
      id
      state
      local_start_date
      local_start_time

      created_by {
        id
        person {
          id
          first_name
          last_name
        }
      }

      modified_by {
        id
        person {
          id
          first_name
          last_name
        }
      }

      created_by_person {
        id
        first_name
        last_name
        patient {
          id
          _id
        }
      }

      modified_by_person {
        id
        first_name
        last_name
        patient {
          id
          _id
        }
      }
    }
  }

  vaxiom_appointments(where: { _id: { _eq: $appointment_id } }) {
    id
    sys_created
    sys_created_at
    created_by {
      id
      person {
        id
        first_name
        last_name
      }
    }
  }
}

`